import { BrowserRouter, Navigate, Route, Routes } from "react-router";

import { ProtectedRoute } from "@/auth/protected-route";
import { AppShell } from "@/components/layout/app-shell";
import { ActivityLogPage } from "@/features/activity-log/activity-log-page";
import { AllCasesPage } from "@/features/all-cases/all-cases-page";
import { ApprovalListPage } from "@/features/approvals/approval-list-page";
import { ApprovalReviewRedirect } from "@/features/approvals/approval-review-redirect";
import { CaseDetailPage } from "@/features/case-detail/case-detail-page";
import { HomePage } from "@/features/home/home-page";
import { MyApplicationListPage } from "@/features/my-applications/my-application-list-page";
import { ApplicationTypePage } from "@/features/new-application/application-type-page";
import { NewApplicationPage } from "@/features/new-application/new-application-page";
import { NotificationListPage } from "@/features/notifications/notification-list-page";
import { PermissionsPage } from "@/features/permissions/permissions-page";
import { ProcessDesignPage } from "@/features/process-design/process-design-page";
import { SecretsPage } from "@/features/secrets/secrets-page";
import { TaskRunRedirect } from "@/features/task-run/task-run-redirect";
import { ForbiddenPage } from "@/routes/forbidden-page";
import { NotFoundPage } from "@/routes/not-found-page";

import { ROUTES } from "./routes";

/**
 * ルート宣言はこの 1 ファイルに集約する。
 * P1（大項目1「ホーム」・2「マイ案件」・3「承認リクエスト」）を実装済み。
 */
export function AppRouter() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<ProtectedRoute />}>
          <Route element={<AppShell />}>
            <Route index element={<HomePage />} />
            <Route
              path={ROUTES.myApplications}
              element={<MyApplicationListPage />}
            />
            <Route
              path={ROUTES.newApplication}
              element={<NewApplicationPage />}
            />
            <Route
              path={ROUTES.approvalRequests}
              element={<ApprovalListPage />}
            />
            <Route
              path={ROUTES.notifications}
              element={<NotificationListPage />}
            />
            <Route path={ROUTES.allCases} element={<AllCasesPage />} />
            <Route path={ROUTES.permissions} element={<PermissionsPage />} />
            {/* 提出は案件詳細に一本化。旧 URL（通知・ブックマーク）は送り直す */}
            <Route path={ROUTES.taskRun} element={<TaskRunRedirect />} />
            <Route path={ROUTES.caseDetail} element={<CaseDetailPage />} />
            {/* 承認も案件詳細に一本化。旧 URL（ブックマーク）は送り直す */}
            <Route
              path={ROUTES.approvalReview}
              element={<ApprovalReviewRedirect />}
            />
            <Route
              path={ROUTES.applicationType}
              element={<ApplicationTypePage />}
            />
            <Route path={ROUTES.activityLog} element={<ActivityLogPage />} />
            {/* モデル選択は任意パラメータなので /process-design も同じ画面が受ける */}
            <Route
              path={ROUTES.processDesignModel}
              element={<ProcessDesignPage />}
            />
            {/* フォーム設計はプロセス設計に統合した（既存のブックマーク向け） */}
            <Route
              path={ROUTES.formDesign}
              element={<Navigate to={ROUTES.processDesign} replace />}
            />
            <Route path={ROUTES.secrets} element={<SecretsPage />} />
            <Route path={ROUTES.forbidden} element={<ForbiddenPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
